export default {
  title404: `404 Not Found`,
  title500: `500 Internal Server error`,
  searchDelivery: term =>
    `Get set for ${term} at Argos. Same Day delivery 7 days a week &pound;3.95, or fast store collection.`,
  mobileResultTitle: `Argos Mobile Search Results`,
  searchResult: term => `Results for ${term}`
}
